











import { Vue, Component, Prop } from 'vue-property-decorator'
import { FileInfo } from '@/api/types'

type Dictionary<T> = { [key: string]: T }

interface RouterLink {
  name?: string;
  params?: { [key: string]: string };
  path?: string;
  query?: Dictionary<string | (string | null)[]>;
}

interface FileInfoWithRouterLink extends FileInfo {
  Link?: RouterLink;
}

@Component({
  name: 'ExplorerTiles'
})
export default class App extends Vue {
  @Prop() files!: FileInfoWithRouterLink[]
  @Prop() xattr!: string[]
}

